// extracted by mini-css-extract-plugin
export var container = "styles-module__container___X4QUT";
export var image = "styles-module__image___QonVN";
export var shimmer = "styles-module__shimmer___sOVbp";
export var metadataContainer = "styles-module__metadataContainer___soZDP";